// extracted by mini-css-extract-plugin
export default {"inner-container-new-color":"layout_component_inner-container-new-color__ktQbN","inner-container":"layout_component_inner-container__rgYbG"};